import {
  StyledContainer,
  StyledLeftContainer,
  StyledBorderContainer,
  StyledOneColumnContainer,
} from './index.styled'

export type Props = {
  leftColumn?: JSX.Element
  rightColumn?: JSX.Element
  isHavingBorder?: boolean
  className?: string
}

const TwoColumnsContainer = ({
  className,
  leftColumn,
  rightColumn,
  isHavingBorder = true,
}: Props) => {
  return rightColumn && leftColumn ? (
    <StyledContainer className={className}>
      <StyledLeftContainer>{leftColumn}</StyledLeftContainer>
      <StyledBorderContainer data-border={isHavingBorder}>
        {rightColumn}
      </StyledBorderContainer>
    </StyledContainer>
  ) : (
    <StyledOneColumnContainer>
      {rightColumn || leftColumn || <></>}
    </StyledOneColumnContainer>
  )
}

export { TwoColumnsContainer }
